export default __webpack_public_path__ + "static/media/sl-testimonial.c0b27272.png";